export default __webpack_public_path__ + "static/media/1922.43f90695.png";